import React from "react";
import { Box } from "@mui/material";
import PatternLock from "components/PatternLock";
import Swal from "sweetalert2";
import { updatePattern } from "api/api_register2FA";
import { clearLocalStorage } from "utils/storage";

function Register2FAPatternLock() {
  const { username } = JSON.parse(localStorage.getItem("user")) || "";

  const handlePatternComplete = (pattern) => {
    const patternString = pattern.join("");
    updatePattern(username, patternString).then((res) => {
      if (res) {
        Swal.fire({
          title: "Xác minh 2 bước đã được bật",
          icon: "success",
        });
        setTimeout(() => {
          clearLocalStorage();
          window.location.href = "/authentication/sign-in";
        }, 1500);
      }
    });
  };

  return (
    <Box width={450} className="form-container touch-none" sx={{ padding: "40px 30px 40px 30px" }}>
      <Box className="fs-20 fw-700">Xác thực qua mẫu hình</Box>
      <Box p={1.5} className="fs-14 gray-80 txt-align">
        Vẽ một mẫu hình để đăng ký xác thực 2 bước
      </Box>
      <PatternLock onPatternComplete={handlePatternComplete} />
    </Box>
  );
}

export default Register2FAPatternLock;
